<template>
  <div v-if="responseData && responseData.length > 0" class="tvm-bv-confirmation mb-4">
    <div class="tvm-bv-confirmation__content d-flex">
      <div v-for="(item, index) in responseData" :key="index" class="mr-2">
        <button class="btn mb-2 rounded-buttons py-2 text-white chips__btn px-4 suggestions_btn bgcolor-primary"
          @click="optionclick(item)">
          {{ item.name }}
        </button>
      </div>
    </div>
    <div v-if="msrpDetailsData && msrpDetailsData.length > 0 && confirmationData" class="tvm-bv-confirmation__details"
      style="display: none;">
      <AiEmailTemplate :email-data="confirmationData.confirmationObj" :vehicle-info="vehicleInfoData"
        :msrp-details="msrpDetailsData" :payment-collection="paymentCollectionData"
        :qualified-data="qualifiedIncentiviesData" />
    </div>
  </div>
</template>
<script>
import { mapState } from 'pinia';
import { usePaymentSettingsStore } from '../../../../store/PaymentSettings/PaymentsettingsStore';
import AiEmailTemplate from './AiEmailTemplate.vue';
import { ChatWidgetService } from '../../../../Services/ChatWidgetService/ChatWidgetService';

export default {
  props: {
    responseData: {
      type: Array,
      required: false
    }
  },
  mounted() {

  },
  computed: {
    ...mapState(usePaymentSettingsStore, ["paymentCollectionData", "msrpDetailsData", "qualifiedIncentiviesData", "vehicleInfoData"]),
    confirmationData() {
      return this.responseData.find(item => item.submitAction === 'tvm_buyavehicle_userconfirmationyes') || null;
    }
  },
  components: {
    AiEmailTemplate
  },
  methods: {
    optionclick(item) {
      ChatWidgetService.postTvmMessage(item.name, null, null,
        item?.submitAction, null);
      try {
        if (item.submitAction === 'tvm_buyavehicle_userconfirmationyes') {
          let htmlBody = '';

          if (document.getElementById('email-quote-template')) {

            htmlBody = document.getElementById('email-quote-template').innerHTML;
            // htmlBody = responsiveStyle + htmlBody;
            const responsiveStyle = `

            <!DOCTYPE html>
            <html lang="en">

            <head>
              <meta charset="UTF-8" />
              <meta name="viewport" content="width=device-width, initial-scale=1.0" />
              <title></title>
              <style>
                body {
                  font-family: Arial, Helvetica, sans-serif;
                  margin: 0;
                  padding: 0;
                  background-color: #f6f6f6;
                  -webkit-text-size-adjust: 100%;
                  -ms-text-size-adjust: 100%;
                }
                .container {
                  width: 100%;
                  max-width: 700px;
                  margin: 20px auto;
                  background-color: #ffffff;
                  border-collapse: collapse;

                }

                .header {
                  padding: 10px;
                  text-align: left;
                }

                .header img {
                  max-width: 100px;
                }

                .header-text {
                  font-size: 12px;
                  color: #555555;
                  text-align: right;
                }

                .vehicle-info {
                  padding: 15px;
                  border-bottom: 1px solid #eeeeee;
                }

                .vehicle-name {
                  font-size: 20px;
                  font-weight: bold;
                  color: #333333;
                  margin: 0 0 5px 0;
                }

                .vehicle-details {
                  font-size: 14px;
                  color: #555555;
                  margin: 0 0 10px 0;
                }

                .vehicle-price {
                  font-size: 28px;
                  font-weight: bold;
                  color: #000000;
                  margin: 10px 0 0 0;
                }

                .options-section {
                  padding: 15px 15px 10px 15px;
                }

                .options-title {
                  font-size: 15px;
                  font-weight: bold;
                  color: #333333;
                  margin: 0 0 15px 0;
                  text-align: center;
                }

                .option-box {
                  border-radius: 5px;
                  padding: 10px;
                  text-align: center;
                  margin-bottom: 10px;
                  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
                  border: 1px solid #eee;
                }

                .option-duration {
                  font-size: 10px;
                  color: #000;
                  background: #edecec;
                  padding: 5px;
                  border-radius: 10px;
                  font-weight: 700;
                }

                .option-price {
                  font-size: 20px;
                  font-weight: bold;
                  color: #000000;
                  padding: 5px 0;
                }

                .option-terms {
                  font-size: 7px;
                  color: #000;
                  margin: 0;
                  font-weight: 900;
                  text-transform: capitalize;
                }

                .popular-option {
                  font-size: 8px;
                  color: #007bff;
                  font-weight: bold;
                  height: 20px;
                }

                .incentives-section {
                  padding: 15px;
                  background-color: #fff;
                }

                .incentive-offer-box {
                  padding: 10px;
                  text-align: center;
                  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
                  border-radius: 5px;
                  border: 1px solid #eee;

                }

                .incentive-title {
                  font-size: 8px;
                  color: #555555;
                  margin: 0 0 5px 0;
                  font-weight: bold;
                }

                .incentive-amount {
                  font-size: 20px;
                  font-weight: bold;
                  color: #000000;
                  padding: 20px 0 5px 0;
                }

                .incentive-description {
                  font-size: 8px;
                  color: #000;
                  margin: 0;
                  font-weight: 900;
                  text-transform: capitalize;
                }

                .qr-code-text {
                  font-size: 9.5px;
                  font-weight: 800;
                  color: #000;
                  margin: 0 0 6px 0;
                }

                .qr-code img {
                  max-width: 80px;
                }

                .footer {
                  font-size: 10px;
                  color: #888888;
                  text-align: center;
                  padding: 10px 20px;
                }

                .disclaimer {
                  font-size: 9px;
                  color: #aaaaaa;
                  text-align: left;
                  padding: 0 20px 20px 20px;
                }

                .px-1 {
                  padding: 0 4px;
                }

                .ft-10 {
                  font-size: 10px;
                }

                .mb-0 {
                  margin-bottom: 0;
                }

                .color_dot {
                  width: 10px;
                  height: 10px;
                  background: #007bff;
                  border-radius: 50%;
                  display: inline-block;
                }

                .text-right {
                  text-align: right;
                }

                .border {
                  border: 1px solid #eee;
                }

                .max-width-80 {
                  max-width: 60%;
                }

                .price_tag {
                  border-radius: 8px;
                  padding: 10px;
                }

                .text-bold {
                  font-weight: bold;
                }

                .popular-option {
                  height: 10px;
                  padding-top: 5px;
                  font-weight: bold;
                }

                .option-terms-conditions {
                  font-size: 9px;
                  color: #555555;
                }


                @media screen and (max-width: 600px) {

                  .options-section table td,
                  .incentives-section table td.incentive-box,
                  .incentives-section table td.qr-code-section {
                    display: block !important;
                    width: 100% !important;
                    box-sizing: border-box !important;

                  }

                  .options-section table td .option-box,
                  .incentives-section table td .incentive-offer-box {
                    margin-bottom: 15px !important;

                  }

                  .incentives-section table td.qr-code-section {
                    padding-top: 15px;

                  }

                  .incentives-section .options-title {
                    width: 100% !important;

                  }


                  .vehicle-info table td img {
                    margin-top: 15px;
                  }

                  .header-text table td {
                    display: none;

                  }

                  #vehicle-info-table .full_width {
                    display: block;
                    width: 100%;

                  }

                  .header-text table {
                    width: 100% !important;
                  }

                  .max-width-80 {
                    max-width: 60%;
                  }
                }
              </style>
            </head>

            <body>
              ${htmlBody}
            </body>

            </html>
            `;
            console.log(responsiveStyle, 'htmlBody')
            const data = ChatWidgetService.sendVehicleQuote(
              {
                accountId: window.accountId,
                campaignId: window.campaignid,
                tId: window.tid,
                htmlBody: responsiveStyle,
              }
            );
            console.log('Email template processed successfully:', data);
          }
        }
      } catch (error) {
        console.error('Error processing email template:', error);
      }
    }
  },
}
</script>
<style lang="">

</style>
